import { render, staticRenderFns } from "./PageVita.vue?vue&type=template&id=bc7e7fa0&scoped=true&"
import script from "./PageVita.vue?vue&type=script&lang=js&"
export * from "./PageVita.vue?vue&type=script&lang=js&"
import style0 from "./PageVita.vue?vue&type=style&index=0&id=bc7e7fa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e7fa0",
  null
  
)

export default component.exports